export const DEFAULT_COUNTRY_CODE = "+1";

const US_NATIONAL_LENGTH = 10;

export const getRecipientDigits = (value?: string | null) => (value ?? "").replace(/\D/g, "");

export const startsWithCountryCode = (value?: string | null) => (value ?? "").trim().startsWith("+");

export const sanitizeRecipientInput = (value: string) => {
  const digits = getRecipientDigits(value);

  return startsWithCountryCode(value) ? `+${digits}` : digits;
};

export const normalizeSmsRecipient = (value: string) => {
  const digits = getRecipientDigits(value);

  if (!digits) return "";

  if (startsWithCountryCode(value)) return `+${digits}`;

  if (digits.length === US_NATIONAL_LENGTH + 1 && digits.startsWith("1")) return `+${digits}`;

  return `${DEFAULT_COUNTRY_CODE}${digits}`;
};

export const formatRecipientLive = (value: string) => {
  const digits = getRecipientDigits(value);

  if (startsWithCountryCode(value)) return `+${digits}`;

  if (digits.length === 0) return "";
  if (digits.length > US_NATIONAL_LENGTH) return digits;
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const isSameSmsRecipient = (left?: string | null, right?: string | null) => {
  const leftDigits = getRecipientDigits(left);
  const rightDigits = getRecipientDigits(right);

  if (!leftDigits || !rightDigits) return false;

  if (leftDigits.length >= US_NATIONAL_LENGTH && rightDigits.length >= US_NATIONAL_LENGTH) {
    return leftDigits.slice(-US_NATIONAL_LENGTH) === rightDigits.slice(-US_NATIONAL_LENGTH);
  }

  return leftDigits === rightDigits;
};

export const getRecipientDedupeKey = (value?: string | null) => {
  const digits = getRecipientDigits(value);

  return digits.length >= US_NATIONAL_LENGTH ? digits.slice(-US_NATIONAL_LENGTH) : digits;
};
